import "mburger-webcomponent";

document.addEventListener("DOMContentLoaded", function () {
	// Parse menu items HTML string into DOM nodes
	const tempDiv = document.createElement("div");

	tempDiv.innerHTML = bds_theme.features.mobile_menu.menu_items;

	const menuItems = Array.from(tempDiv.childNodes);

	const mobileMenu = new Mmenu(
		...menuItems,
		{
			...bds_theme.features.mobile_menu.mmenu_opts,
		},
		{
			classNames: {
				selected: "current-menu-item",
			},
			offCanvas: {
				clone: false, // We handle this on our own to clean up the markup.
				page: {
					selector: ".wp-site-blocks",
				},
			},
		},
	);

	const api = mobileMenu.API;

	// Handle burger click
	document.querySelectorAll("mm-burger").forEach(function (burger) {
		burger.addEventListener("click", function (event) {
			event.preventDefault();
			api.open();
		});
	});

	// Handle menu items whose href values are '#'
	document.querySelectorAll(".mm-listitem__text").forEach(function (itemText) {
		itemText.addEventListener("click", function (event) {
			const href = event.target.getAttribute("href");
			if (href && href[href.length - 1] === "#") {
				const nextBtn = itemText.nextElementSibling;
				if (nextBtn && nextBtn.classList.contains("mm-btn--next")) {
					const panelHref = nextBtn.getAttribute("href");
					if (panelHref) {
						api.openPanel(panelHref);
					}
				}
			}
		});
	});
});
